import React from 'react'
import { Table, TableContainer, Paper, TableContainerProps, TableProps } from '@mui/material'
import { TableComponents, TableVirtuoso } from 'react-virtuoso'

type ScrollerProps = React.ComponentProps<'div'> & {
  style?: React.CSSProperties
}

type TableComponentProps = React.ComponentProps<'table'> & {
  style?: React.CSSProperties
}

type TableBodyProps = React.ComponentProps<'tbody'> & {
  style?: React.CSSProperties
}

const CustomTableRow = React.forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLDivElement>>(({ children }) => {
  return <>{children}</>
})

/* eslint-disable @typescript-eslint/no-explicit-any */
export const VirtuosoTableComponents: TableComponents<any, unknown> = {
  Scroller: React.forwardRef<HTMLDivElement, ScrollerProps>((props, ref) => (
    <TableContainer
      component={Paper}
      {...(props as TableContainerProps)}
      ref={ref as React.ForwardedRef<HTMLDivElement>}
    />
  )),

  Table: (props: TableComponentProps) => (
    <Table {...(props as TableProps)} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
  ),

  TableRow: CustomTableRow,

  TableBody: React.forwardRef<HTMLTableSectionElement, TableBodyProps>((props, ref) => <tbody {...props} ref={ref} />),
}

const COLLAPSED_ROW_HEIGHT = 74
const EXPANDED_ROW_HEIGHT = 131

export interface VirtualizedTableProps<T> {
  data: T[]
  expandedRows: { [key: number]: boolean }
  headerContent: () => React.ReactNode
  rowContent: (index: number, item: T) => React.ReactNode
}

export default function VirtualizedTable<T>({
  data,
  expandedRows,
  headerContent,
  rowContent,
}: VirtualizedTableProps<T>) {
  const getRowHeight = React.useCallback(
    (element: HTMLElement) => {
      const index = Number(element.getAttribute('data-index'))
      return expandedRows[index] ? EXPANDED_ROW_HEIGHT : COLLAPSED_ROW_HEIGHT
    },
    [expandedRows],
  )

  return (
    <TableVirtuoso
      style={{ height: '600px' }}
      data={data}
      components={VirtuosoTableComponents}
      fixedHeaderContent={headerContent}
      itemContent={rowContent}
      overscan={5}
      defaultItemHeight={COLLAPSED_ROW_HEIGHT}
      itemSize={getRowHeight}
    />
  )
}
